import { useEffect, useState } from 'react';

const LARGE_SCREEN_WIDTH = 1024;
const SMALL_SCREEN_WIDTH = 640;

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window || {
    innerWidth: 0,
    innerHeight: 0,
  };

  return { width, height };
};

export const isLargeScreen = (width: number) => width >= LARGE_SCREEN_WIDTH;
export const isSmallScreen = (width: number) => width < SMALL_SCREEN_WIDTH;

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};
